import { Component, OnInit, Input } from '@angular/core';
import { SensorsDeviceTypesMap, SensorsDeviceType} from '../../devices.constant';
import { Device } from '../../devices.model_new';

@Component({
  selector: 'app-sensor-detail',
  templateUrl: './sensor-detail.component.html',
  styleUrls: ['./sensor-detail.component.scss']
})
export class SensorDetailComponent implements OnInit {
  @Input()
  device: Device;
  SensorsDeviceTypesMap = SensorsDeviceTypesMap;
  constructor() { }

  ngOnInit() {
  }

  getDeviceSubType(): string {
    let subType;
    this.device.getGroups().forEach(group => {
      if (SensorsDeviceTypesMap.map.get(SensorsDeviceType.DOOR_WINDOW).groups.includes(group)) {
        subType = SensorsDeviceType.DOOR_WINDOW;
      } else if (SensorsDeviceTypesMap.map.get(SensorsDeviceType.FLOOD).groups.includes(group)) {
        subType = SensorsDeviceType.FLOOD;
      } else if (SensorsDeviceTypesMap.map.get(SensorsDeviceType.MOTION).groups.includes(group)) {
        subType = SensorsDeviceType.MOTION;
      } else if (SensorsDeviceTypesMap.map.get(SensorsDeviceType.SMOKE).groups.includes(group)) {
        subType = SensorsDeviceType.SMOKE;
      }
    });
    return subType;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/devices/device-detail/sensor-detail/sensor-detail.component.ts